<template>
    <div id="guarantee-profile-form" class="mt-2">
        <!-- {{ guarantee_profile }} -->
        <!-- {{ allSections }} -->
        <div class="vx-row p-2">
            <div class="vx-col w-full">
                <h3 class="mb-1">Información del obligado solidario.</h3>
                <p>Contar con un obligado solidario te permite obtener mejores condiciones para tu crédito y puede
                    responder por el pago del mismo.</p>
                <vs-divider></vs-divider>
            </div>
            <!-- content -->
            <div class="ml-4 mr-4 p-2 vx-col w-full">
                <div v-if="isMounted" class="main-form mt-2">
                    <!-- FORM FIELDS -->
                    <div class="vx-row">

                        <!-- OS STATUS -->
                        <vx-card title="" class="w-full mb-base">
                            <h4>Detalle del Obligado solidario.</h4>
                            <div class="vx-row">
                                <div class="vx-col w-1/3">
                                    <vs-list>
                                        <vs-list-item title="Onboarding step">{{ base.guarantee_profile_step || "--"
                                            }}</vs-list-item>
                                        <vs-list-item title="Autorización de consulta CDC NIP">
                                            {{ lastCreditRequest != null ?
                    humanizedCompactDate(lastCreditRequest.created_at) : "--" }}
                                        </vs-list-item>
                                        <vs-list-item title="Caducidad de NIP">
                                            {{ lastCreditRequest != null ? dateDiff(lastCreditRequest.created_at, 3) :
                    "--" }}
                                        </vs-list-item>
                                        <vs-list-item title="Syntage">
                                            {{ lastSatProfile != null ?
                    translateSyntageStatus(lastSatProfile.credential_status) : "Sin realizar" }}
                                        </vs-list-item>
                                    </vs-list>
                                </div>
                                <div class="vx-col w-2/3">
                                    <vs-alert v-if="base.rejected_date != null" icon-pack="feather" style="height:auto"
                                        icon="icon-alert-triangle" class="mt-0 mb-6" color="danger">
                                        <span class="font-regular"><strong>Obligado Solidario Rechazado</strong><br>
                                            <span>
                                                El obligado solidario fue rechazado, para continuar con el proceso será
                                                necesario que actualices la información con un nuevo obligado solidario.
                                            </span>
                                        </span>
                                    </vs-alert>

                                    <vs-alert v-if="base.approved_date != null" icon-pack="feather" style="height:auto"
                                        icon="icon-info" class="mt-0 mb-6" color="success">
                                        <span class="font-regular"><strong>Obligado Solidario Verificado</strong><br>
                                            <span>
                                                El obligado solidario se verificó exitosamente.
                                            </span>
                                            <div class="flex flex-wrap items-center justify-end">
                                                <vs-button size="small" color="primary" class="ml-2 mt-2"
                                                    @click="requestToUpdateObligatedStatus(2)">Desverificar</vs-button>
                                            </div>
                                        </span>
                                    </vs-alert>
                                    <div class="vx-row mb-6"
                                        v-if="base.approved_date == null && base.rejected_date == null">
                                        <div class="vx-col w-full">
                                            <div class="flex flex-wrap items-center justify-start">
                                                <vs-button color="success" class="ml-auto mt-2"
                                                    @click="requestToUpdateObligatedStatus(1)">
                                                    Verificar
                                                </vs-button>
                                                <vs-button color="danger" class="ml-2 mt-2"
                                                    @click="requestToUpdateObligatedStatus()">Rechazar</vs-button>
                                                <vs-button v-if="!isMoral" @click="goToCdcService()"
                                                    class="flex-none ml-auto mt-2 mr-4 text-black" color="secondary">
                                                    Ir al buro de crédito
                                                </vs-button>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="vx-row w-full mb-2">
                                        <vs-button v-if="base.approved_date == null" @click="requestDeleteOs()"
                                            class="flex-none ml-auto mt-2 mr-4 text-white" color="black">
                                            Eliminar de solcitud
                                        </vs-button>
                                    </div>
                                </div>
                            </div>
                        </vx-card>

                        <vx-card v-for="section in allSections" :key="section.id" :title="get_section_name(section)"
                            class="mb-5">
                            <p class="mb-4" v-if="section.public_description != null">{{ section.public_description }}
                            </p>
                            <vs-alert v-if="section.failed > 0" icon-pack="feather" style="height:auto"
                                icon="icon-alert-triangle" class="mt-0 mb-base" color="danger">
                                <span class="font-regular">Campos faltantes:<br>
                                    <span v-for="(miss, i) in section.missing" :key="i">
                                        <strong>- {{ miss.n }}: </strong> {{ miss.e }}<br>
                                    </span>
                                </span>
                            </vs-alert>

                            <div class="vx-row">
                                <template v-for="f in section.fields">
                                    <!-- Campos automaticos -->
                                    <form-field v-if="isAutoFormField(f)" :ref="`section${section.id}`" :key="f.id"
                                        :f="f" :dataContainer="getContainerForField(section, f)"
                                        :collectionsRoot="collections" :onChangeReceptor="onFieldChange"
                                        :hasBackofficeAccess="true" :blockedByDocument="f.blockedByDocument"
                                        :evaluator="evaluateCondition" :inputClassLarge="true"
                                        :countriesList="collections.countries" :editableByBackoffice="true" />
                                </template>
                            </div>
                            <!-- Save Button -->
                            <div class="vx-row">
                                <div class="vx-col w-full">
                                    <div class="text-right">
                                        <vs-button class="ml-auto mt-2" @click="saveGroupChanges(section)">
                                            Guardar cambios
                                        </vs-button>
                                    </div>
                                </div>
                            </div>
                            <div class="vx-row">
                                <vs-button @click="goToCdcService()" v-if="isObligatedSection(section.id)"
                                    class="flex-none ml-auto mt-2 mr-4 text-black" color="secondary">
                                    Ir al buro de crédito
                                </vs-button>
                            </div>
                            <template v-if="section.documentFields.length > 0">
                                <vs-divider></vs-divider>
                                <h6 class="mb-3">Documentos</h6>
                                <div class="vx-row">
                                    <document-upload 
                                        v-for="df in section.documentFields" 
                                        :key="df.id"
                                        :target_id="df.target_id" 
                                        :f="df.formField" 
                                        :doc="df.documentSet"
                                        :inputClassLarge="false" 
                                        :disabled="false"
                                        :evaluator="evaluateCondition" 
                                        :loadedState="df.loadedState"
                                        :stickToLoadedState="true" 
                                        :from_project_id="currentProjectId"
                                        :editableByBackoffice="true" 
                                        :canVerify="hasRole('credit_risk') || hasRole('project_operator')"
                                        @on-success="onDocumentUploadSuccess" />
                                </div>
                            </template>
                        </vx-card>
                    </div>
                    <!-- FIELDS -->

                    <!-- BOTONES -->

                </div>
            </div>
        </div>
    </div>
</template>

<script>
import inputHelper from "@mixins/inputHelper";
import formatHelper from "@mixins/formatHelper";
import FormField from '@components/forms/FormField.vue';
import docsHelper from '@components/mixins/docsHelper';
import formHelper from '@components/mixins/formHelper';
import dateHelper from '@mixins/dateHelper';
import stpHelper from "@mixins/stpHelper";
import projectStatusesHelper from "@mixins/projectStatusesHelper";
import { Validator } from 'vee-validate'

const sectionsToContainers = [
    {
        id: 19, containers: [
            { db: 'guarantee_profiles', path: 'base' },
            { db: 'personal_profiles', path: 'personal' },
            { db: 'personal_credit_profiles', path: 'personal.credit_profile' },
            { db: 'phones', path: 'personal.phone' },
        ]
    },
    {
        id: 20, containers: [{ db: 'addresses', path: 'personal.address' }]
    },
    {
        id: 21, containers: [
            { db: 'guarantee_profiles', path: 'base' },
            { db: 'personal_profiles', path: 'personal' },
            { db: 'personal_credit_profiles', path: 'personal.credit_profile' },
            { db: 'phones', path: 'personal.phone' },
        ]
    },
    {
        id: 122, containers: [
            { db: 'guarantee_profiles', path: 'base' },
            { db: 'business_profiles', path: 'business' },
            { db: 'business_credit_profiles', path: 'business.credit_profile' },
        ]
    },
    {
        id: 123, containers: [
            { db: 'personal_profiles', path: 'business.personal' },
            { db: 'guarantee_profiles', path: 'base' },
            { db: 'phones', path: 'business.personal.phone' },
        ]
    },
    {
        id: 124, containers: [
            { db: 'addresses', path: 'business.address' }
        ]
    },
    {
        id: 125, containers: [
            { db: 'business_profiles', path: 'business' },
            { db: 'business_credit_profiles', path: 'business.credit_profile' },
            { db: 'guarantee_profiles', path: 'base' },
        ]
    },
    {
        id: 149, containers: [
            { db: 'addresses', path: 'business.personal.address' }
        ]
    },
];

const genderDefs = [
    { k: 1, v: "HOMBRE" },
    { k: 2, v: "MUJER" },
];

const obligatedSections = [123];

const verifiedEnumValue = "verificado";
const rejectedEnumValue = "rechazado";
const unverifiedEnumValue = "sin verificar";


export default {
    name: "GuaranteeProfileForm",
    mixins: [
        inputHelper,
        formatHelper,
        docsHelper,
        formHelper,
        dateHelper,
        stpHelper,
        projectStatusesHelper
    ],
    components: {
        FormField
    },
    props: {
        guarantee: Object,
        currentProjectId: null,
        userId: null
    },
    data: () => ({
        base: {},
        isMounted: false,
        colClass: "vx-col w-full mb-5",
        emailRules: 'required|email',
        emailPlaceholder: 'ejemplo@mail.com',
        requiredPlaceholder: '(Requerido)',
        colReferencesClass: 'vx-col sm:w-1/2 md:w-1/10 mb-5',
        pmSections: [122, 123, 124],
        pfSections: [19, 20],
        allSections: [],
        formSections: [],

        allSections: [],
        formSections: [],

        documentsFields: [],
        documentsStates: [],

        validatedDocuments: [],
        allDocumentFields: [],
        marriedMaritalStatusId: 2,
        collections: {
            countries: [],
            genders: genderDefs,
            states_guarantee_profile_address: [],
            cities_guarantee_profile_address: [],
            neighborhoods_guarantee_profile_address: [],
        },
        slas: {
            min_guarantee_age: null,
            max_guarantee_age: null,
        },
        referenceDuplicated: null,
        newReference: {
            name: null,
            phone: null,
            country_calling_code: null,
            phone_id: null,
            email: null,
            relation_with_applicant: null,
        },
        showReferenceDuplicatedPropmt: false,
        relationTypes: [],
        getOptionsForSelect: [],
        obligatedSections: obligatedSections,
        // objetos para actualizaciones
        basePayload: {},
        validatedFields: [],
        totalFields: 0,
        totalValidFields: 0,
        totalInvalidFields: 0,
        mexicoCountryId: 700,
        isRejected: 0,
    }),
    async mounted() {
        this.showLoading(true, "Cargando información...");
        this.isMounted = false;
        this.base = this.guarantee;
        await this.getCollections();
        await this.getSections();
        this.guaranteeProfile.relation_with_applicant = this.guaranteeProfile.relation_with_applicant == 0 ? null : this.guaranteeProfile.relation_with_applicant;
        this.isMounted = true;
        this.showLoading(false);
    },
    computed: {
        isMoral() {
            return this.guarantee_profile.business_profile_id != null;
        },
        projectId() {
            return this.base.id;
        },
        current_section() {
            return this.isMoral ? this.pmSections : this.pfSections;
        },
        guarantee_profile() {
            return this.guarantee;
        },
        guaranteeIsRejected() {
            return this.base.rejected_date != null;
        },
        personal() {
            return this.guaranteeProfile.personal;
        },
        business() {
            return this.guaranteeProfile.business;
        },
        is_guarantee_personal_completed() {
            return this.personal.curp != null && this.personal.rfc != null && this.personal.phone_id != null && this.personal.first_name != null && this.personal.last_name_1 != null;
        },
        guaranteeProfile() {
            return this.guarantee_profile;
        },
        guaranteeName() {
            return this.isMoral ? this.business.name : this.personal.first_name + " " + this.personal.last_name_1;
        },
        guaranteeMail() {
            return this.isMoral ? this.business.name : this.personal.first_name + " " + this.personal.last_name_1;
        },
        obligated_status() {
            let obligated = this.base;
            if (obligated) {
                let status = "updated";
                if (obligated.rejected_date != null) {
                    status = "rejected";
                } else if (obligated.approved_date != null) {
                    status = "approved";
                }
                return status;
            } else {
                return obligated;
            }
        },
        lastCreditRequest() {
            if (this.isMoral) {
                return this.business.last_credit_request;
            } else {
                return this.personal.last_credit_request;
            }
        },
        lastSatProfile() {
            if (this.isMoral) {
                return this.business.last_sat_profile;
            } else {
                return this.personal.last_sat_profile;
            }
        },
        is_address_mexican() {
            return this.personal?.address.country_id == this.mexicoCountryId;
        },
        is_address_foreign() {
            return this.personal?.address.country_id != this.mexicoCountryId;
        },
        is_not_a_different_profile() {
            return true;
        },
        owner_business_profile_address_is_mexican() {
            return this.business.personal.address.country_id == this.mexicoCountryId;
        },
        guarantee_exist() {
            return this.guaranteeProfile && this.guaranteeProfile.id != null;
        },
        guarantee_profile_id() {
            return this.guaranteeProfile.id;
        }
    },
    methods: {
        onSelect(dialCode) {
            this.newReference.country_calling_code = dialCode.dialCode;
        },
        async validate_client_unique_phone() {
            try {

                const payload = {
                    phone: this.personal.phone.phone
                };

                const res = await axios.post(`/api/v1/forms/validate-phone-in-project/${this.base.id}`, payload);
                if (res.data == 1) {
                    this.missingFieldsNotif(null, "El teléfono ya está registrado dentro de la solicitud, el teléfono debe ser diferente al del solicitante y referencias. ");
                    return false;
                }

                return true;
            } catch (error) {
                console.log(error);
                return false;
            }
        },
        showFields(fname) {
            return true;
        },
        async getSections() {
            try {
                const sections = this.isMoral ? this.pmSections : this.pfSections;
                const res = await axios.post("/api/v1/forms/getSectionsByArrayIds", { section_ids: sections });
                this.allSections = res.data.sections;

                let id = this.isMoral ? 5 : 4;
                let url = this.ApiDomain + `/storagev3/documents/flow/${id}`;
                let response2 = await axios.get(url);
                this.documentsStates = response2.data;

                this.allDocumentFields = [];

                await this.asyncForEach(this.allSections, async (s) => {
                    s.containers = this.getContainersForSection(s.id);
                    s.documentFields = [];
                    s.failed = 0;
                    s.missing = [];

                    let co = 0;
                    await this.asyncForEach(s.fields, async (f) => {
                        this.formFieldSetter(f, this);
                        if (this.isAutoFieldToSave(f)) {
                            co += 1
                        }

                        // check for documents
                        if (f.doc_id != null) {

                            if (s.id == 27) {
                                if (f.doc_id == 31 || f.doc_id == 26)
                                    return;
                            }

                            let ff = { formField: f, documentSet: null, target_id: null };
                            let ss = this.documentsStates.find(sid => sid.id == s.id);
                            if (ss && ss.documents) {
                                let dset = ss.documents.find(d => d.id == f.doc_id);
                                if (dset) {
                                    ff.target_id = this.docTargetEvaluator(dset.clasification, dset.clasification_2);
                                    ff.documentSet = dset;
                                }
                            }
                            s.documentFields.push(ff);
                            this.allDocumentFields.push(ff);
                        }
                    });
                    if (co == 0) {
                        s.skipBtn = true;
                    }
                });
                let res2 = await this.getAllDocumentsStates(this.allDocumentFields, this.evaluateCondition);
                if (res2) {
                    this.allDocumentFields.forEach(f => {
                        if (f.loadedState && f.loadedState.is_verified == verifiedEnumValue) {
                            this.validatedDocuments.push(f.documentSet.id);
                        }
                    })
                }
            } catch (error) {
                console.log(error);
            }
        },
        getContainersForSection(section_id) {
            let c = sectionsToContainers.find(f => f.id == section_id);
            if (!c) {
                this.warn("Missing containers definition for section " + section_id);
                return null;
            }
            else {
                let sectionContainers = [];
                c.containers.forEach(cc => {
                    let con = this.setContainerFromDef(cc);
                    sectionContainers.push({ db: cc.db, path: cc.path, container: con });
                })
                return sectionContainers;
            }
        },
        async getCollections() {
            try {
                let collectionsObjects = ['countriesList'];

                let params = "with[]=" + collectionsObjects.join("&with[]=");
                let res = await axios.get(`/api/v1/forms/getFormCollections?${params}`);
                this.collections.countries = res.data.countriesList;

                let slasObjects = ['min_guarantee_age', 'max_guarantee_age'];
                let slasParams = "with[]=" + slasObjects.join("&with[]=");
                let slasRes = await axios.get(`/api/v1/forms/getSlasValues?${slasParams}`);
                this.slas = slasRes.data;

                let res1 = await axios.get("/api/v1/forms/getProjectRelatedProfilesRelationTypes");
                this.relationTypes = res1.data;

                let options = [];
                this.relationTypes.forEach(opt => {
                    options.push({ value: opt.type, text: opt.name }); //conversion a sintaxis de vx-select 
                })
                this.getOptionsForSelect = options;
            }
            catch (e) {
                console.log(error);
                this.warn(e);
                this.failed = true;
            }
        },
        // GUARDAR
        async saveSections(gslug) {
            // let uniqueCurp = await this.validate_unique_curp(this.personal.curp, this.personal.id);
            // if(!uniqueCurp){
            //     this.sendIdentifiersNotification(
            //         {
            //             user_id: this.guarantee.id,
            //             loan_id: this.projectId,
            //             role: "guarantee",
            //             flow: "CURP",
            //             id: this.personal.curp
            //         }
            //     );
            //     return;
            // }

            let result = await this.runValidations(gslug);
            if (!result) {
                if (!this.skipMissingWarnings) {
                    this.missingFieldsNotif();
                }
            } else {
                this.showLoading(true, "Guardando información...");
                //guardar solo la informacion que se ha modificado
                this.basePayload = this.collectFormData(gslug);
                if (this.objectIsEmpty(this.basePayload)) {
                    this.showLoading(false);
                    this.showGuaranteeAlert();
                    await this.requestGuaranteeAuthorization();
                    // this.createStpAccount(this.base.client.id);
                    // await this.checkIfCanUpdateLoanOnboardingStep(this.base.id);
                    await this.$emit("saved", 0);
                    await this.$emit("updated", 1);
                    return;
                }

                this.basePayload.id = this.base.id;
                this.guaranteeProfile.guarantee_type = { value: 1 }
                try {
                    // ejecutar guardado
                    this.injectAccountMetadataToPayload(this.basePayload);
                    await axios.put(`/api/v2/projects/${this.projectId}/deepUpdate`, this.basePayload);
                    // solicitar la informacion actualizada del modelo
                    this.showLoading(false);
                    this.showGuaranteeAlert();
                    await this.requestGuaranteeAuthorization();
                    await this.$emit("saved", 0);
                    await this.$emit("updated", 1);
                    this.saveSuccessNotif();
                }
                catch (error) {
                    this.showLoading(false);
                    this.warn(error);
                    this.failedOperationNotif(null, null);
                }

                // se crea la cuenta stp
                try {
                    await this.createStpAccount(this.base.client.id);
                } catch (error) {
                    console.log("No se generó la cuenta STP");
                }

            }
        },
        showGuaranteeAlert() {
            this.$vs.dialog({
                color: 'success',
                title: 'Notificaremos a tu obligado.',
                text: `Enviaremos un correo a tu Obligado Solidario (${this.guaranteeName} - ${this.guaranteeProfile.email}) en donde se le solicitará verifique su identidad y autorice la consulta de historial crediticio.
                        \n Por favor comunícate con el/ella para que no se extrañe de este correo y nos ayude en tu proceso de solicitud de crédito.`,
                acceptText: "Continuar",
            });
        },
        async requestGuaranteeAuthorization() {
            try {
                const res = await axios.post(`/api/loan-onboarding/post/${this.projectId}/guarantee-notification`);
            } catch (error) {
                console.log(error);
            }
        },
        async runValidations(gslug) {
            // validar componentes tipo FormField
            let res1 = await this.validateFormFields(gslug);
            if (!res1) {
                return false;
            }

            // validar inputs instanciados en la vista
            let res2 = await this.$validator.validateAll();
            if (!res2) {
                return false;
            }

            // Valida que el correo del OS no sea igual que el del solicitante
            let emailIsUnique = await this.validate_is_guarantee_email_equal_to_applicants();
            if (!emailIsUnique) {
                /**
                 * Buscar la referencia a la que se parece
                 * Preguntar que esa es una referencia y que si desea continuar con el como OS 
                 * Si no, que cambie el correo de os.
                 * Sí decide cambiar al OS tiene que cambiar la referencia y dar de alta una nueva y el form de os lo deja igual.
                 */
                return false;
            }

            // Valida que el correo del OS no sea igual que el del solicitante
            let phoneValidation = await this.validate_client_unique_phone();
            if (!phoneValidation) {
                return false;
            }

            // retornar true si todas las validaciones fueron positivas
            return true;
        },

        async getDuplicatedReference() {
            // applicant/reference-duplicated
            try {
                const res = await axios.post(`/api/applicant/reference-duplicated`, {
                    applicant_id: this.base.client.id,
                    email: this.guarantee.email
                });

                // console.log(res.data);
                this.referenceDuplicated = res.data;

                if (this.referenceDuplicated != null) {
                    this.$vs.dialog({
                        type: 'confirm',
                        color: 'warning',
                        title: 'Tu obligado solidario ya es una referencia.',
                        text: `El obligado solidario ingresasdo ya es una referencia, si deseas continuar con éste obligado solidario debes agregar una referencia adicional.`,
                        acceptText: "Aceptar",
                        cancelText: 'Cancelar',
                        accept: this.addNewReference,
                        cancel: null
                    });
                }


            } catch (error) {
                console.log(error);
            }
        },
        addNewReference() {
            this.showReferenceDuplicatedPropmt = true;
        },
        async saveReferences() {
            try {
                if (this.newReference.name == null || this.newReference.phone == null || this.newReference.email == null || this.newReference.relationType == null) {
                    this.missingFieldsNotif();
                    return;
                }

                this.newReference.phone_id = this.referenceDuplicated.phone_id;

                this.showLoading(true, "Guardando referencia...");
                const res = await axios.post(`/api/applicant/${this.ApplicantId}/save-reference/${this.referenceDuplicated.id}`, {
                    reference: this.newReference
                });
                this.showReferenceDuplicatedPropmt = false;
                this.showLoading(false);
                this.saveSuccessNotif();

            } catch (error) {
                this.showLoading(false);
                this.failedOperationNotif();
                console.log(error);
            }
        },
        collectFormData(section) {
            let payload = {};
            section.containers.forEach(cc => {
                let fields = this.validatedFields.filter(vf => vf.db == cc.db);
                if (fields.length < 1) {
                    return;
                }

                if (cc.path == "base") {
                    fields.forEach(f => {
                        payload[f.fname] = cc.container[f.fname];
                    });
                } else {
                    let obj = null;
                    obj = { id: cc.container.id };
                    fields.forEach(f => {
                        obj[f.fname] = cc.container[f.fname];
                    });
                    // ajuste para objetos tipo array
                    this.setNestedObjectWithIds(payload, this.base, cc.path, obj);
                    // this.get_project_financed_interests_percentage(payload);
                }
            });
            return payload;
        },
        async validateFormFields(refGroup, section_id = null) {
            let allValid = true;
            if (this.base.rejected_date == null) {
                this.validatedFields = [];
            }
            let grefs = this.$refs[refGroup];
            for (let p in grefs) {
                let r = await this.$refs[refGroup][p].checkForValidDirty();
                if (r.valid == false) {
                    allValid = false;
                } else if (r.dirty == true) {
                    this.validatedFields.push(r);
                }
            }
            return allValid;
        },
        getContainerForField(section, f) {
            if (!section.containers) {
                return null;
            }

            let c = section.containers.find(sc => sc.db == f.db_table);
            if (!c) {
                this.warn(`Container not found for db [${f.fname}]: ${f.db_table}`);
                return null;
            } else {
                return c.container;
            }
        },
        setContainerFromDef(c) {
            let container = this.nestedFieldValue(this.base, c.path);
            if (Array.isArray(container)) {
                let ac = null;
                if (c.arrayDefs) {
                    if (c.arrayDefs.getFirst == true) {
                        ac = container[0];
                    } else if (c.arrayDefs.eval) {
                        // llamado en funciones de secciones
                        ac = this[c.arrayDefs.eval](container);
                    }
                }
                if (!ac) {
                    if (c.arrayDefs.onNull) {
                        if (c.arrayDefs.onNull in this) {
                            ac = this[c.arrayDefs.onNull]();
                        } else {
                            this.warn("Missing method definition for container " + c.path + ", " + c.db + ": " + c.arrayDefs.onNull);
                        }
                    } else {
                        ac = {}
                    }
                    container.push(ac);
                }
                return ac;
            } else {
                if (!container && c.objDefs && c.objDefs.onNull) {
                    if (c.objDefs.onNull in this) {
                        container = this[c.objDefs.onNull]();
                    } else {
                        this.warn("Missing method definition for container " + c.path + ", " + c.db + ": " + c.objDefs.onNull);
                    }
                }
                if (!container) {
                    this.setNestedObjectWithIds(this.base, this.base, c.path, {});
                }
                return this.nestedFieldValue(this.base, c.path);
            }
        },
        client_curp_conditions_changed() {
            this.trigger_curp_conditions_changed(this.personal);
        },
        PF_PFAE_guarantee_profile_curp_conditions_changed() {
            this.trigger_curp_conditions_changed(this.personal);
        },

        trigger_curp_conditions_changed(obj) {
            let c = obj["curp"];
            if (!c) { return; }
            if (c.length >= 10) {
                let yy = c.slice(4, 6);
                let mm = c.slice(6, 8);
                let dd = c.slice(8, 10);

                let date = this.getDateFromInputs(yy, mm, dd);
                if (date === false) {
                    obj["birth_date"] = null;
                }
                else {
                    obj["birth_date"] = date;
                }
            }
            else {
                obj["birth_date"] = null;
            }

            if (c.length >= 11) {
                let g = c.slice(10, 11);
                if (g == "H") {
                    obj["gender"] = 1;
                }
                else if (g == "M") {
                    obj["gender"] = 2;
                }
                else {
                    obj["gender"] = null;
                }
            }
            else {
                obj["gender"] = null;
            }
        },
        /* evaluator */
        evaluateCondition(condition) {
            return this.evaluateConditionBase(this, condition);
        },
        /* on change receptor */
        onFieldChange(method) {
            if (method != null && method in this) {
                this[method]();
            }
        },
        /* validaciones especiales */
        validate_client_age_legal() {
            let years = this.calculateAgeFromDate(this.personal.birth_date);
            let min = parseInt(this.slas.min_guarantee_age);
            let max = parseInt(this.slas.max_guarantee_age);
            return years >= min && years <= max;
        },
        client_birthdate_invalid() {
            return `El obligado solidario debe tener entre ${this.slas.min_guarantee_age} y ${this.slas.max_guarantee_age} años`;
        },
        async validate_client_unique_rfc() {
            return await this.validate_unique_personal_rfc(this.personal.rfc, this.personal.id)
        },
        async pf_validate_guarantee_profile_unique_curp() {
            return await this.validate_unique_curp(this.personal.curp, this.personal.id);
        },
        async validate_client_unique_curp() {
            return await this.validate_unique_curp(this.personal.curp, this.personal.id)
        },
        async validate_is_guarantee_email_equal_to_applicants() {
            return !await this.isEmailDuplicatedInProject(this.guarantee.email, this.base.id, {
                tableName: 'guarantee_profiles',
                key: 'id',
                value: this.guarantee.id
            });
        },
        hasError(val) {
            return this.errors.has(val);
        },
        errorText(val) {
            return this.errors.first(val);
        },
        isSuccess(val) {
            let ff = this.fields[val];
            return ff && ff.required && ff.valid;
        },
        validate_guarantee_age() {
            let years = this.calculateAgeFromDate(this.personal.birth_date);
            let min = parseInt(this.slas.min_guarantee_age);
            let max = parseInt(this.slas.max_guarantee_age);
            return years >= min && years <= max;
        },
        guarantee_birthdate_invalid() {
            return `El obligado solidario debe tener entre ${this.slas.min_guarantee_age} y ${this.slas.max_guarantee_age} años`;
        },
        get_section_name(section) {
            return `${section.id} - ${section.public_name}`;
        },
        async saveGroupChanges(section) {
            // if(this.PCP && this.PCP.id != null && this.personal.credit_profile.employer_address_id == null && this.payload.source_address == 2){
            //   this.personal.credit_profile.employer_address_id = this.PCP.id;
            // }

            // if(this.obligated_status == "rejected"){
            //   let r = await this.validateOSClean();
            //   if(r){
            //     this.SaveFullOS(r); // SE GUARDAN MULTIPLES SECCIONES
            //     this.loading = false;
            //     this.validatedFields = [];
            //   } else {
            //     return;
            //   }
            // } else {
            // ## Se elimina validación a petición de Operaciones ST-679.
            // let result = await this.runValidations(section);
            // if(!result){
            //   this.missingFieldsNotif();
            // } else {

            // validar componentes tipo FormField
            let gslug = "section" + section.id;
            let res1 = await this.validateFormFields(gslug, section.id);
            // if(!res1){
            //   return false;
            // }

            this.loading = true;
            //guardar solo la informacion que se ha modificado
            this.basePayload = this.collectFormData(section);

            if (this.objectIsEmpty(this.basePayload)) {
                //this.notFieldsToUpdate();
                this.saveSuccessNotif();
                this.loading = false;
                return;
            }

            this.basePayload.id = this.base.id;

            try {
                // ejecutar guardado
                await axios.post(`/api/guarantee/update/onboarding/${this.base.id}/deepUpdate/${this.base.auth_token}`, this.basePayload);

                // solicitar la informacion actualizada del modelo
                await this.$emit("updated", 1);

                this.saveSuccessNotif();
            } catch (error) {
                console.log(error);
                this.failedOperationNotif(null, null);
            }

            this.loading = false;

            // }
            // }
        },
        goToCdcService() {
            let guaranteeProfileId = this.base.personal_profile_id;
            window.open('/score/personal-profile/' + guaranteeProfileId, '_blank')
        },
        isObligatedSection(section_id) {
            return this.obligatedSections.some(section => section == section_id);
        },
        async requestToUpdateObligatedStatus(isRejected = 0) {
            if (isRejected == 1) {
                let ok = await this.checkForOSVerification();
                if (!ok) {
                    return;
                }
            }
            let action = "";
            switch (isRejected) {
                case 0:
                    action = "RECHAZAR";
                    break;
                case 1:
                    action = "VERIFICAR";
                    break;
                case 2:
                    action = "DESVERIFICAR";
                    break;
            }
            let obligated = this.base;
            this.isRejected = isRejected;
            this.$vs.dialog({
                type: 'confirm',
                color: 'warning',
                title: "Acción de Obligado Solidario",
                text: `¿Estás seguro de <<${action}>> al obligado solidario con email <<${obligated.email}>>?`,
                acceptText: "Confirmar",
                cancelText: 'Cancelar',
                accept: this.doRequestToUpdateObligatedStatus
            });
        },
        async doRequestToUpdateObligatedStatus() {
            try {
                this.showLoading(true);
                let obligated = this.base;
                let payload = {
                    isRejected: this.isRejected
                    , form_project_id: this.currentProjectId
                    , guarantee_id: obligated.id
                    , guarantee_name: this.getGuaranteeName(obligated)
                    , guarantee_type: this.isMoral ? 2 : 1
                };

                // actualizar guarantee_profile.
                await axios.post(`/api/project/updateGuarantee`, payload);

                this.isRejected = 0;
                // solicitar la informacion actualizada del modelo
                await this.$emit("updated", 1);

                this.saveSuccessNotif();
            } catch (error) {
                console.log(error);
                this.failedOperationNotif(null, null);
            } finally {
                this.showLoading(false);
            }
        },
        async checkForOSVerification() {
            // this.showLoading(true)
            let text = "Existen campos pendientes para realizar la verificación del Obligado Solidario";
            this.isMounted = false;
            // TODO verificar datos desde back
            await this.runPreRequestSilentValidation(true);
            this.isMounted = true;
            // this.showLoading(false)
            if (this.totalInvalidFields > 0) {
                this.errorNotif("Campos pendientes",
                    text, 10000);
                return false;
            }
            return true;
        },
        async runPreRequestSilentValidation(isObligated = false) {
            this.resetCounters();
            let validator = new Validator();
            let container;

            await this.asyncForEach(this.allSections, async (section) => {
                section.missing = [];
                section.failed = 0;
                await this.asyncForEach(section.fields, async (f) => {
                    container = this.getContainerForField(section, f);
                    if (this.notDocumentNorPrivate(f)) {
                        if (this.isAutoFormField(f)) {
                            let res = await this.evaluateFieldCompletition(f, container, this.evaluateCondition, validator);
                            // console.log(section.id + ", " + f.fname + "=> " + res);
                            if (res != null) {
                                if (res == false) {
                                    section.failed += 1;
                                    section.missing.push({ n: f.field_name, e: "Campo requerido" });
                                    this.totalInvalidFields += 1;
                                }
                            }
                        } else if (f.special_definition == 1 && f.hard_validation) {
                            let res = await this[f.hard_validation.method]();
                            if (!res) {
                                section.failed += 1;
                                if (f.hard_validation.custom_error != null) {
                                    const customError = await this[f.hard_validation.custom_error]();
                                    section.missing.push({ n: f.field_name, e: customError });
                                } else {
                                    section.missing.push({ n: f.field_name, e: f.hard_validation.error });
                                }
                                this.totalInvalidFields += 1;
                            }
                        }
                        this.totalFields += 1;
                    }
                });

                section.documentFields.forEach(df => {
                    if (!df.loadedState && df.documentSet.is_required == 1 && df.formField.bo_private != 1) {
                        if (df.formField.show_conditioned) {
                            let inc = this.evaluateCondition(df.formField.condition);
                            if (inc != true) {
                                return;
                            }
                        }
                        section.failed += 1;
                        this.totalInvalidFields += 1;
                        section.missing.push({ n: df.documentSet.name, e: "Documento requerido" });
                    } else if (df.loadedState && df.loadedState.is_verified == rejectedEnumValue) {
                        section.failed += 1;
                        this.totalInvalidFields += 1;
                        section.missing.push({ n: df.documentSet.name, e: "Documento en estatus rechazado" });
                    }
                });

                // console.log(section.id + "=> " + section.failed + " / " + section.missing.length);
            });
        },
        resetCounters() {
            this.totalFields = 0;
            this.totalValidFields = 0;
            this.totalInvalidFields = 0;
            this.accreditationsMissing = null;
        },
        getGuaranteeName(guarantee) {
            try {
                if (guarantee.personal_profile_id != null) {
                    const personal = guarantee.personal;
                    return `${personal.first_name} ${personal.last_name_1}`;
                } else {
                    const business = guarantee.business;
                    return business.name;
                }
            } catch (error) {
                console.log(error);
                return "NA";
            }
        },
        verify_zip_code_guarantee_profile_address() {
            if (this.isMoral) {
                this.verifyZipCode(this.business.address, {
                    zipCodeVariable: 'zip_code_guarantee_profile_address',
                    statesArray: 'states_guarantee_profile_address',
                    citiesArray: 'cities_guarantee_profile_address',
                    neighborhoodsArray: 'neighborhoods_guarantee_profile_address'
                });
            } else {
                this.verifyZipCode(this.personal.address, {
                    zipCodeVariable: 'zip_code_guarantee_profile_address',
                    statesArray: 'states_guarantee_profile_address',
                    citiesArray: 'cities_guarantee_profile_address',
                    neighborhoodsArray: 'neighborhoods_guarantee_profile_address'
                });
            }
        },
        set_zip_code_values_guarantee_profile_address() {
            if (this.isMoral) {
                this.guaranteeCountryId = this.nestedFieldValue(this.base, "business.address.country_id");
                this.should_fill_mexican_guarantee_address = this.guaranteeCountryId == this.mexicoCountryId;
                this.should_fill_foreign_guarantee_address = this.guaranteeCountryId != this.mexicoCountryId;

                this.setZipCodeAddressValues(this.business.address_id, this.business.address, {
                    zipCodeVariable: 'zip_code_guarantee_profile_address',
                    statesArray: 'states_guarantee_profile_address',
                    citiesArray: 'cities_guarantee_profile_address',
                    neighborhoodsArray: 'neighborhoods_guarantee_profile_address'
                });
            } else {
                this.guaranteeCountryId = this.nestedFieldValue(this.base, "personal.address.country_id");
                this.should_fill_mexican_guarantee_address = this.guaranteeCountryId == this.mexicoCountryId;
                this.should_fill_foreign_guarantee_address = this.guaranteeCountryId != this.mexicoCountryId;

                this.setZipCodeAddressValues(this.personal.address_id, this.personal.address, {
                    zipCodeVariable: 'zip_code_guarantee_profile_address',
                    statesArray: 'states_guarantee_profile_address',
                    citiesArray: 'cities_guarantee_profile_address',
                    neighborhoodsArray: 'neighborhoods_guarantee_profile_address'
                });
            }
        },
        verify_zip_code_owner_business_profile_address() {
            this.verifyZipCode(this.business.personal.address, {
                zipCodeVariable: 'zip_code_owner_business_profile_address',
                statesArray: 'states_guarantee_profile_address',
                citiesArray: 'cities_guarantee_profile_address',
                neighborhoodsArray: 'neighborhoods_guarantee_profile_address'
            });
        },
        set_zip_code_values_owner_business_profile_address() {
            this.setZipCodeAddressValues(this.business.personal.address_id, this.business.personal.address, {
                zipCodeVariable: 'zip_code_owner_business_profile_address',
                statesArray: 'states_guarantee_profile_address',
                citiesArray: 'cities_guarantee_profile_address',
                neighborhoodsArray: 'neighborhoods_guarantee_profile_address'
            });
        },
        pm_guarantee_profile_curp_conditions_changed() {
            this.trigger_curp_conditions_changed(this.business.personal);
        },
        trigger_curp_conditions_changed(obj) {
            let c = obj["curp"];
            if (!c) {
                return;
            }
            if (c.length >= 10) {
                let yy = c.slice(4, 6);
                let mm = c.slice(6, 8);
                let dd = c.slice(8, 10);

                let date = this.getDateFromInputs(yy, mm, dd);
                if (date === false) {
                    obj["birth_date"] = null;
                } else {
                    obj["birth_date"] = date;
                }
            } else {
                obj["birth_date"] = null;
            }

            if (c.length >= 11) {
                let g = c.slice(10, 11);
                if (g == "H") {
                    obj["gender"] = 1;
                } else if (g == "M") {
                    obj["gender"] = 2;
                } else {
                    obj["gender"] = null;
                }
            } else {
                obj["gender"] = null;
            }
        },
        async pf_validate_moral_guarantee_profile_unique_curp() {
            return await this.validate_unique_curp(this.business.personal.curp, this.business.personal.id);
        },
        async validate_pm_guarantee_personal_unique_rfc() {
            return await this.validate_unique_personal_rfc(this.business.personal.rfc, this.business.personal.id)
        },
        /* obtener ids para los casos correspondientes */
        docTargetEvaluator(cls, cls_2) {
            if (cls == 'user') {
                if (cls_2 == 'supplier') {
                    return this.currentSupplierUserId;
                } else if (cls_2 == 'applicant') {
                    return this.userId;
                }
            } else if (cls == 'project') {
                return this.currentProjectId;
            }
            this.warn(`DOC TARGET NOT DEFINED FOR classifications: ${cls},${cls_2}`);
            return null;
        },
        onDocumentUploadSuccess(data) {
            let d = this.allDocumentFields.find(f => f.documentSet.id == data.document_id);
            d.loadedState = data;
        },
        requestDeleteOs() {
            this.$vs.dialog({
                type: 'confirm',
                color: 'danger',
                title: "Eliminar Obligado Solidario",
                text: `¿Estás seguro de eliminar al obligado solidario con email <<${this.base.email}>>? Esta acción no se puede deshacer.`,
                acceptText: "Confirmar",
                cancelText: 'Cancelar',
                accept: this.doRequestDeleteOs
            });
        },
        async doRequestDeleteOs() {
            try {
                this.showLoading(true);
                let obligated = this.base;
                let payload = {
                    loan_id: this.currentProjectId,
                    guarantee_id: obligated.id,
                };

                // eliminar guarantee_profile.
                await axios.post(`/api/guarantee/post/onboarding/delete-guarantee`, payload);

                // solicitar la informacion actualizada del modelo
                await this.$emit("updated", 1);

                this.saveSuccessNotif();
            } catch (error) {
                console.log(error);
                this.failedOperationNotif(null, null);
            } finally {
                this.showLoading(false);
            }
        }
    }
}
</script>